import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Helmet from "react-helmet";
import ContactForm from "./components/contactForm.js"


const useStyles = makeStyles((theme) => ({
    container: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: '#fff',
    },
    wrapper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        flexGrow: 1,
        width: 1024,
        margin: "auto",
        [theme.breakpoints.down('lg')]: {
            width: "100%",
            margin: "none,"
        },
    },
    header: {
        background: '#fff',
        color: '#413e40',
        textAlign: "left",
        marginLeft: 40,
        marginTop: 40,
        marginBottom: 20,
    },
    section: {
        background: '#fff',
        color: '#413e40',
        textAlign: "left",
        marginLeft: 40,
        marginTop: 20,
        marginBottom: 20,
        marginRight: 40,
    }
}));


export default function Deliveries() {
    const classes = useStyles();

    return (

        <React.Fragment>
            <Helmet>
                <title>Jigpaws – Free shipping | Delivery times and FAQs</title>
                <meta name="description"
                      content="Free shipping | Delivery times and FAQs"/>
                {/*<link rel="canonical" href="https://www.jigpaws.com/deliveries-and-returns"/>*/}
                <meta property="og:url"
                      content="https://www.jigpaws.com/contact"/>
                <meta property="og:type" content="article"/>
                <meta property="og:title" content="Jigpaws – Contact Us"/>
                <meta property="og:description"
                      content="Get in touch with Jigpaws"/>
                <meta property="og:image" content="https://www.jigpaws.com/images/social-logo.png"/>
            </Helmet>
            <div className={classes.container}>
                <Container className={"productsHome bgGray"} disableGutters={true} maxWidth={false}>
                    <div className="spacer"/>
                    <div><h1>Contact Us</h1></div>
                    <div className="spacer"></div>
                    <div className="jpDivider bgBlue"/>

                </Container>

                <div className={classes.wrapper}>
                    <div className="contactForm">
                        <h4><strong>
                            Questions before ordering?<br/> Need help with an existing order?</strong>
                        </h4>

                        <body>We’re here to help every step of the way — whether you have a question about uploading
                        your photo, product options, delivery times, shipping, or order updates.
                        </body>
                        <div className="spacerSmall"/>

                        <body>Simply complete the form below and our customer care team will get back to you as quickly
                        as possible.
                        </body>
                        <div className="spacerSmall"/>

                        <body>
                        <ul>
                            <li>✅ Friendly human support</li>
                            <li>✅ Help with photo uploads & cropping</li>
                            <li>✅ Delivery & shipping advice</li>
                            <li>✅ Order and product questions</li>
                        </ul>
                        </body>
                        <div className="spacerSmall"/>

                        <body>
                        Prefer email? You can reach us anytime at <a
                            href="mailto:support@jigpaws.com">support@jigpaws.com</a>
                        </body>
                        <body>
                        We’re here to make creating your personalised gift easy and stress-free.
                        </body>
                        <div className="spacerMed"/>
                        <ContactForm/>

                    </div>
                </div>

            </div>
        </React.Fragment>
    );
}